import React, { useEffect } from 'react'
import { useState } from 'react';
import searchIcon from '../../../../assets/images/Search_Icon.png';
import RequestForReopen_Icon from './../../../../assets/onboard-images/RequestForReopen_Icon.png'
import RequestForDisbaled_Icon from './../../../../assets/onboard-images/RequestForDisbaled_Icon.png'
import Edit_Icon from './../../../../assets/images/Edit_Icon.png';
import deleteIcon from './../../../../assets/onboard-images/Delete_Icon.png'
import Eye_ViewDetails_Icon from './../../../../assets/onboard-images/Eye_ViewDetails_Icon.png';
import { useHistory } from 'react-router-dom';
import AdminBreadcrumb from '../../../Administration/General/Admin-breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { getOnboardAccounts, getRoleTabData, updateReOpenRequestStart, updateReOpenRequestSuccess, viewAccountDetails } from '../../../../actions/Onboard.action';
import { ActivateModelPopup } from '../../../Administration/Administration_firstpage.js/ActivationModel';
import { AccountDeleted, DeleteModalPopup, OnboardRequestAdmin } from '../Modals/DeleteModalPopup';
import './Onboardlanding.css';
import TooltipHandler from './../TooltipHandler';
import { updateDeleteAccountStart } from './../../../../actions/Onboard.action';
import { DeleteFragment, DeletedModalPopup } from './../Modals/DeleteModalPopup';
import { getRoleBasedView } from '../../../../actions/Administration/admin.action';
const MOCK_DATA = [
  {
    // "path": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAgCAYAAABNXxW6AAAABHNCSVQICAgIfAhkiAAABc9JREFUaEPtmQlslEUUgL8t0Hu7rQWlR2JiAgoCRg1yHyZyCAKCHHKraIIBFChgOEzAiKXbg2LTxEgDKFC0UI4i0NKCCCgIltNCCiIBCgilXba73X/dbru+gS7WDaelpUD/pElnZ+a9N997b97M/+s64R/egQbteDwfZxyWjbop6AdOJ2jtY8Sg7CIO43doR2Oxfq/W/VhA0IHzFF7RyRTtX4Vto6fDH2UIDgn1aHAdSMCScbtIf9Qg2K/QyLicK0ck1NPvNsUfeggS6mVncMQYKd2/FtttPX4rKCKj/qmHoKrDVALfmoZhdR2NB+0E5fFbKMmNwbahpmysi3uC4xiumIUU79yEPaemFl5Vbl2BYJdyFlOBbmci5u21sfC6AqH0NJY4Oaruiackq7YX/sAguMB+DEeceP2nrFoK9buBq+uE9/Od8B1yN4OrM+YIjpxM7LurI6Om5taXSFUi2+PdoiO+w6pP2WU9h2Wh1Nry6suqXQnVrQ72XMpjEzBn/Yj2c+2afv+0/R8INtnYYhtSlmlE23v/THlwku4WglkWntgAV3YslofW47e8QN3qzZLsmJZ9lCXGY8ncifbLg/NTzWv2jATtIBbjArSMXZQdqHn1dUODQAjqLV5v70L3w0LMv9UNs2rXivpzgjon1C7zuqmtHoKKhCgCB0VhuPFSUofOHEZB8CQCXptJcPYSirrMqTzzp9I4tTs+w3Nx7OpHYdcLRMid6N8nnPP/gSr9TultIH9OqTLvyG1x5VACxiYSvMw9ax22lTmUzU/GcMxTVl+8Wy2mydEPMfXdgG2z6i8gYuh27KO/xjkmjcBiT52XiXTtwL4xEWviGkJzpN+rLb5dN6CfH05hl8mEtvgEv8MuXM4ZmD5agS3lRnUQA6ddN0LnkP+T0gn5ogP+Mw9jjXsd8/QJ+DSfTeN8OS98/Cq+T8uYLS/T6IUX8e7UE6+njNjTpS+h6kLEYMdxqTKZaOujCIp+n6thgdBrESEz4jAvUWPzKT/+B7Zf30A/diqGOfk4zm5C+1bJWorfkF48kXYSZ0Y3Lg1Q4y/TZGgmFaOXUD46lQDTLSCsFwhJAmHbHhzLFmBZmikQQq87rsKEz8wtmCJH4D9G5gfdgCBK5yklByiJ2wHWizJY3Lq4AkbIQH1nCEkjojiXv41JXPlsK5Sq8e8ROCmBBs8FY57gmfEKwmpKv1nK1XmZRJwby5XmITTsKBBmxVKyyksmxFEy1z1PDDyTgW3veEzX7jLnidS8qEiWyjVFbFARda8QVIRXDKBooIIwnsLuiyQ6PcFVOSfo8pSSJMzdLLhaz8KwXe4EbcQ7R4dR3G4X2r5XaNhhPU8ukGjpOobCljk4jt8Jgiy0kZKbR9nBHlx+qTIdkkTGWfV7OAWtbgahP95tvqLJYbGhtaTr0c1og8dRnH4vkZBO6HIdrjwnOpMfjvCqENyprIDcgFCVThqhn3fGd7bbuENY4/tgnibG9IjHnH1R8i4F66JPuTr5ThAkvFecw7k3goaDelDYW0GQSBgs+04/z8ipGglLCBnVG//l7jHyEmbDuxS9ea8QBnC5jzjukA+O3ZIO3URH+VRMbdviZxiO71YVYTeFIKng+hLrkGjMayYSNGomQSn9KdBnEPGnpEik+rY3ipKm27AU3QmCSocUtJhsGp9UoG+2MU7ANEottiqEC0TaZW+I+oCi5J74tVtG6E6JGh9PCG5IKrWaivzKjfHanqAiIYzzESLXIhAOCYQuCQSnvE3AODXvII7kvhROlDdL6NsSGCmTjlcK9JqBvpkRS75bgbSfdbfVK/oErOtUrqn+1rJX9CbAJ5bSvzw9OxV98zzKLVnYLioZ+7Cct0i16I4+zD32JOUlsg9cUG35Ot7sd8q0LWgFVXWqvsr2ibli7xH85DO6diFK5LvlyOVOZ5Q1SLVreVpk7kUrHokhLBbzqUjwG4lvkxjs11JwCoZnLuFonCoprtr/AMcSuj+5sSMvAAAAAElFTkSuQmCC",
    "Account Name": "Audi",
    "Site Name": "Derby UK",
    "Created By": "Hruby, Tomas (thruby@dxc.com)",
    "Valid From": "08/05/2021",
    "Valid TO": "08/07/2023",
    // "Status": "Saved"
  }]
const Headers = [
  {
    id: 1,
    label: "Account Logo"
  },
  {
    id: 2,
    label: "Account Name"
  },
  {
    id: 3,
    label: "Site Name"
  },
  {
    id: 4,
    label: "Created By"
  },
  {
    id: 5,
    label: "Created Date"
  },
  {
    id: 6,
    label: "Valid From"
  },
  {
    id: 7,
    label: "Valid To"
  },
  {
    id: 8,
    label: "Status"
  },
  {
    id: 9,
    label: ""
  },
  {
    id: 10,
    label: ""
  },
  {
    id: 11,
    label: ""
  }
]
const OnboardLanding = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  let onboardAccounts = useSelector((state) => state.onboardReducer.onboardAccounts);
  const [onboardAccountsData, setOnboardAccountsData] = useState(MOCK_DATA);
  const [viewDetailsID, setViewDetailsID] = useState(null);
  const [deleteAccountObj, setDeleteAccountObj] = useState()
  const accountData = [];

  useEffect(() => {
    dispatch(getOnboardAccounts())
  }, [dispatch]);

  useEffect(() => {

  }, [])
  const [filter, setFilter] = useState('');
  const [searchColumns, setSearchColumns] = useState([]);
  function searchRows(rows) {
    return rows.filter((row) =>
      searchColumns.some(
        (column) =>
          row[column]
            .toString()
            .toLowerCase()
            .indexOf(filter.toLowerCase()) > -1,
      ),
    );
  };
  const StatusHandleIcon = (status) => {
    switch (status) {
      case 'Saved': return Edit_Icon;
      case 'Submitted': return RequestForReopen_Icon;
      case 'Pending': return RequestForDisbaled_Icon;
      case 'Re-Open': return Edit_Icon;
      case 'Completed': return '';
      default: { }
    }
  }
  const StatusHandleText = (status) => {
    switch (status) {
      case 'Saved':
      case 'Re-Open':
        return 'Edit Account Details';
      case 'Submitted': return 'Request for Re-open';
      case 'Pending': return 'Re-open request sent to administrator';
      case 'Completed': return '';
      default: { }
    }
  }
  const StatusColorHandle = (status) => {
    switch (status) {
      //  case 'Saved': return '#ffbb33';
      // case 'Submitted': return '#33b5e5';
      case 'Pending': return '#ff4444';
      //case 'Re-Open': return '#00695c';
      //case 'Completed': return '#00C851';
      default: { }
    }
  }
  useEffect(() => {
    setOnboardAccountsData((onboardAccounts.statusCode) ? [] : onboardAccounts);
    setSearchColumns(['Account Name', 'Site Name', 'Created By'])
  }, [onboardAccounts]);


  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [month, day, year].join('/');
  }
  const AccountViewDetailsHandle = (id) => {
    let selectedAccount = onboardAccountsData[id - 1];
    let temp_arr = {
      AccountName: selectedAccount['Account Name'],
      SiteName: selectedAccount['Site Name'],
      ValidFrom: formatDate(selectedAccount['Valid From']),
      ValidTo: formatDate(selectedAccount['Valid To']),
      mode: 'view',
    }
    dispatch(viewAccountDetails(temp_arr))
    history.push('/onboardAccount')
  }



  const [showReuqestModal, setShowRequestModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAccountDeletedModal, setShowAccountDeletedModal] = useState(false)

  const AccountEditDetailsHandle = (id, status) => {
    setViewDetailsID(id);
    let selectedAccount = onboardAccountsData[id - 1];
    let temp_arr = {
      AccountName: selectedAccount['Account Name'],
      SiteName: selectedAccount['Site Name'],
      ValidFrom: formatDate(selectedAccount['Valid From']),
      ValidTo: formatDate(selectedAccount['Valid To']),
      mode: 'edit',
    }
    let temp_arr2 = {
      Account: selectedAccount['Account Name'],
      Servicedesk: selectedAccount['Site Name'],
      Status: "Submitted"
    }

    switch (status) {
      case 'Re-Open':
      case 'Saved': {
        dispatch(viewAccountDetails(temp_arr))
        history.push('/onboardAccount')
        break
      }
      case 'Completed': { break }
      case 'Submitted': {
        dispatch(updateReOpenRequestStart(temp_arr2))
        dispatch(getOnboardAccounts())
        setShowRequestModal(true);
        break;
      }
      default: { }
    }
  }

  const AccountDeleteHandle = (info) => {
    let dispObj = {
      Customer:info?.['Account Name'],
      ServiceDesk:info?.['Site Name']
    }
    setDeleteAccountObj(dispObj)
    setShowDeleteModal(true)
    }
  const handleYesDeleteAccount = () =>{
    setShowDeleteModal(false)
    dispatch(updateDeleteAccountStart(deleteAccountObj))
    dispatch(getOnboardAccounts())
    setShowAccountDeletedModal(true)
  }
  const handleNoDeleteAccount = () =>{
    setShowDeleteModal(false)
  }

  const AccountCreateDetails = () => {

    let temp_arr = {}
    dispatch(viewAccountDetails(temp_arr))
    history.push('/onboardAccount')
  }

  const getClientCustID = () => {
    return onboardAccounts.CustomerID;
  };

  const RoleBasedView = useSelector((state) => state.adminAccountReducer.RoleBasedView);
    useEffect(() => {
        dispatch(getRoleBasedView())
    }, [dispatch])
  return (

    <section style={{ marginTop: '5em', width: '100%' }}>
      <AdminBreadcrumb value1={()=>history.push('/welcome')} label1='Home' isActive2={false} label2='Onboard' />
      <main style={{ display: 'flex', justifyContent: 'space-between', width: '94%', marginLeft: 10 }}><div className='first_header'>Onboard</div>
       {(RoleBasedView?.[0]?.AccountOnboard?.[0]?.ReadWrite === 1) ? <div><button className='onboard_newacc_btn' onClick={AccountCreateDetails}>Onboard New Account</button></div>: ''}
        </main>
      <main className="container_acc" style={{ width: "94%", left: 10, marginTop: 10 }} >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}><div className="accounts__text" >Accounts</div>
          <div> <span className='search-bar-role' style={{ marginTop: 10, marginRight: 20 }}>
            <input className='search-input-role' value={filter || ''} onChange={e => setFilter(e.target.value)} placeholder='Search Accounts' />
            <button className='search-icon'><img src={searchIcon} alt='' /> </button>
          </span></div>
        </div>
        {searchRows(onboardAccountsData)?.length === 0 ?
          <section>
            <table style={{ width: '100%', marginTop: '1em' }} className='queue-table'>
              <thead className='admin_trclass'>
                <tr className='admin_trclass'>
                  {Headers.map(header => (<th className='table_head_admin' key={header.id}> {header.label}</th>))}
                </tr>
              </thead>
            </table>
            <section className='noData-table'>
              <div className='noData-para' style={{ marginTop: 0 }}>
                <div style={{ marginTop: 30 }}>
                  No records found.<br /> To onboard new Account entries, click on "Onboard New Account"  button.
                </div>
              </div>
            </section>
          </section>
          :
          <section className='table-section' >
            <table className='report-table' style={{ width: '100%', maxHeight: '519px', paddingLeft: 20 }}>
              <thead className='admin_trclass'>
                <tr className='admin_trclass'>
                  {Headers.map(header => (<th className='table_head_admin' key={header.id}> {header.label}</th>))}
                </tr>
              </thead>
              <tbody className='admin_trclass'>
                {searchRows(onboardAccountsData).map((info) => (
                  <tr className='admin_trclass' key={info?.RowNo} >
                    <td className='tbody_admin'><div><img
                    style={{maxHeight:'40px',maxWidth:'60px'}}
                    // height='20px'
                    // width='60px'
                  type="image/jpeg"
                  src={`${process.env.REACT_APP_BASE_URL
                    }/api/org/customer/${info?.CustomerID}/photo`}
                  alt="Client Logo"
                /></div></td>
                    <td className='tbody_admin'>{info?.['Account Name']}</td>
                    <td className='tbody_admin'>{info?.['Site Name']}</td>
                    <td className='tbody_admin'>{info?.['Created By']}</td>
                    <td className='tbody_admin'>{formatDate(info?.['Created Date'])}</td>
                    <td className='tbody_admin'>{formatDate(info?.['Valid From'])}</td>
                    <td className='tbody_admin'>{formatDate(info?.['Valid To'])}</td>
                    <td className='tbody_admin' style={{ color: StatusColorHandle(info?.Status) }}>{info?.Status}</td>
                    <td className='tbody_admin'>
                      <span style={{ cursor: 'pointer' }} onClick={() => AccountEditDetailsHandle(info?.RowNo, info?.Status)}>
                      {info?.Status === 'Completed'? '' : <TooltipHandler src={StatusHandleIcon(info?.Status)} position='bottom right'
                          textBoxWidth={info?.Status === 'Pending' ? '250px' : '185px'} arrowAlign='center' text={StatusHandleText(info?.Status)} />}</span>
                    </td>
                    <td className='tbody_admin'>
                      <span style={{ cursor: 'pointer' }} onClick={() => AccountDeleteHandle(info)}>
                      {info?.Status !== 'Saved'? '' : <TooltipHandler src={deleteIcon} position='bottom right'
                          textBoxWidth={'200px'} arrowAlign='center' text='Delete Account Details' />}</span>
                    </td>
                    <td className='tbody_admin'><span style={{ cursor: 'pointer' }} onClick={() => AccountViewDetailsHandle(info?.RowNo)} >
                      <TooltipHandler src={Eye_ViewDetails_Icon} position='bottom right'
                        arrowAlign='center' textBoxWidth='130px' text='View Details' /></span>
                    </td>
                  </tr>
                ))}
                <br /><br /><br /><br />
              </tbody>
            </table>
          </section>}
      </main>
      {
        showReuqestModal && <ActivateModelPopup isOpen={showReuqestModal} setShowModal={setShowRequestModal}>
          <OnboardRequestAdmin
            accountName={onboardAccountsData[onboardAccountsData.findIndex((_, index) => index === viewDetailsID)]['Account Name']}
            siteName={onboardAccountsData[onboardAccountsData.findIndex((_, index) => index === viewDetailsID)]['Site Name']}
            email={onboardAccountsData[onboardAccountsData.findIndex((_, index) => index === viewDetailsID)]['Created By']} requestHeading="Request for Re-open"
            onClick={() => {
              dispatch(getOnboardAccounts())
              setShowRequestModal(false)
            }}
          />
        </ActivateModelPopup>
      }

      {showDeleteModal && <DeleteModalPopup isOpen={showDeleteModal} setShowModal={setShowDeleteModal}>
            <DeleteFragment modalName='Delete Account' buttonOne='YES' buttonTwo='NO'
                delete={true}
                handleDeleteQueue={handleYesDeleteAccount}
                handleDeleteQueueCancel={handleNoDeleteAccount}
                queueName={deleteAccountObj.Customer}
                sitename={deleteAccountObj.ServiceDesk}
            />
        </DeleteModalPopup>}

        {showAccountDeletedModal && <DeletedModalPopup isOpen={showAccountDeletedModal} setShowModal={setShowAccountDeletedModal}>
            <AccountDeleted
             accountName = {deleteAccountObj.Customer}
             sitename ={deleteAccountObj.ServiceDesk}
             handleClose = {()=>{setShowAccountDeletedModal(false);dispatch(getOnboardAccounts())}}
           />
        </DeletedModalPopup>}
    </section>

  )
}

export default OnboardLanding